import register from '@kpsys/angularjs-register';

import SearchedInventoryController from './searched-inventory.controller';

/**
 * @ngdoc module
 * @name portaro.inventory
 * @module portaro.inventory
 */

export default register('portaro.inventory')
    .controller(SearchedInventoryController.controllerName, SearchedInventoryController)
    .name();
